'use strict';
const mmWidgets = require('./mm-widgets'),
	validAccountName = require('@mindmup/mindmup-common/src/valid-account-name'),
	validEmail = require('@mindmup/js-utils/src/valid-email');

require('./show-error');
require('./show-progress-message');
require('./section-handler-widget');

mmWidgets.fn.registrationDetailsWidget = function (sectionName, subscriptionModel, navigatorModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			emailField = widget.find('[name="registration-email-address"]'),
			accountNameField = widget.find('[name="registration-account-name"]'),
			registerButton = widget.find('[data-mm-role~="register"]'),
			validateAccountName = function (dontMark) {
				const accountName = accountNameField.val(),
					controlBlock = accountNameField.parent();
				let valid = true;
				controlBlock.removeClass('error');
				if (accountName && !validAccountName(accountName)) {
					valid = false;
				}
				if (!dontMark && !valid && accountName) {
					controlBlock.addClass('error');
				}
				return valid && accountName;
			},
			validatedEmail = function (email) {
				if (!email || validEmail(email)) {
					return email;
				}
			},
			validateEmail = function (dontMark) {
				const email = validatedEmail(emailField.val()),
					controlBlock = emailField.parent();
				let valid = true;

				controlBlock.removeClass('error');
				if (!email) {
					valid = false;
				}
				if (!dontMark && !valid && emailField.val()) {
					controlBlock.addClass('error');
				}
				return valid && email;
			},
			validate = function (dontMark) {
				const validAccountName = validateAccountName(dontMark),
					validEmail = validateEmail(dontMark);
				if (validAccountName && validEmail) {
					registerButton.removeClass('disabled');
					return {
						accountName: validAccountName,
						email: validEmail
					};
				} else {
					registerButton.addClass('disabled');
				}
			},
			validateAndMark = function () {
				validate();
			};
		emailField.blur(validateAndMark).focus(validateAndMark).on('keyup', validateAndMark);
		accountNameField.blur(validateAndMark).focus(validateAndMark).on('keyup', validateAndMark);

		validate(true);

		widget.on('reset', function () {
			if (!emailField.attr('data-mm-using-suggested-email')) {
				emailField.val('');
			}
			accountNameField.val('');
			validate(true);
			widget.trigger('resetComplete');
		});
		registerButton.click(function () {
			const registrationDetails = validate();
			widget.find('[data-mm-role~="error"]').addClass('hidden');
			if (!registrationDetails) {
				return;
			}
			widget.showProgressMessage('Registering with MindMup...');
			subscriptionModel.register(registrationDetails.accountName, registrationDetails.email, navigatorModel.getHostName())
			.catch(function (reason) {
				const knownError = widget.find('[data-mm-role="error"][data-mm-reason="' +  reason + '"]');
				if (knownError.length) {
					knownError.removeClass('hidden');
				} else {
					widget.find('[data-mm-role="error"]').removeClass('hidden');
					widget.find('[data-mm-role="error"][data-mm-reason]').addClass('hidden');
				}
				widget.showSection(sectionName);
			});
		});

	});

};
